import * as yup from 'yup';
import { memorizeMultipleArgs } from 'axp-fx-common';
import * as errorMsg from '../constants/validationMessages';
import constraints from '../constants/validationConstraints';
import { isValueTruthy } from './globalUtils';

export const agreementValidation = () => yup
  .string()
  .test('agreementValidation', errorMsg.TERMS_OF_USE_ERR, (val) => isValueTruthy(val));

export const otpStringValidation = (label) => yup
  .string()
  .nullable()
  .min(constraints.OTP_LIMIT, errorMsg.OTP_LIMIT_ERROR)
  .max(constraints.OTP_LIMIT, errorMsg.OTP_LIMIT_ERROR)
  .matches(constraints.NUMERIC_REGEX, errorMsg.NUMERIC_REGEX_ERROR(label))
  .trim()
  .required(errorMsg.REQUIRED_ERROR(label));

const validateNoError = memorizeMultipleArgs(async (value, ctx) => {
  const { errorMessage } = ctx.options.context;
  if (errorMessage) {
    return ctx.createError({ message: errorMessage });
  }
  return true;
});

export const otpValidation = (label) => yup
  .string()
  .nullable()
  .when(['$errorMessage'], {
    is: (errorMessage) => errorMessage,
    then: otpStringValidation(label)
      .test('validation', '', validateNoError),
    otherwise: otpStringValidation(label),
  });

export const securityPinValidation = (label) => yup
  .string()
  .nullable()
  .min(constraints.SECURITY_PIN_MIN, errorMsg.SECURITY_PIN_LIMIT_ERROR)
  .max(constraints.SECURITY_PIN_MAX, errorMsg.SECURITY_PIN_LIMIT_ERROR)
  .matches(constraints.NUMERIC_REGEX, errorMsg.NUMERIC_REGEX_ERROR(label))
  .trim()
  .required(errorMsg.REQUIRED_ERROR(label));

export const passwordValidation = (label) => yup
  .string()
  .nullable()
  .max(constraints.PASSWORD_MAX, errorMsg.MAX_ERROR(label, constraints.PASSWORD_MAX))
  .min(constraints.PASSWORD_MIN, errorMsg.MIN_ERROR(label, constraints.PASSWORD_MIN))
  .matches(
    constraints.CREDENTIAL_PASSWORD_COMMON_REGEX,
    errorMsg.PASSWORD_COMMON_REGEX_ERR
  )
  .required(errorMsg.REQUIRED_ERROR(label));

export const confPasswordValidation = (passField, label) => yup
  .string()
  .nullable()
  .oneOf([yup.ref(passField)], errorMsg.PASSWORD_NOT_MATCH_ERR)
  .required(errorMsg.REQUIRED_ERROR(label));

export const contactNameValidation = (label) => yup.string()
  .max(constraints.CONTACT_NM_MAX, errorMsg.MAX_ERROR(label, constraints.CONTACT_NM_MAX))
  .min(constraints.CONTACT_NM_MIN, errorMsg.MIN_ERROR(label, constraints.CONTACT_NM_MIN))
  .matches(constraints.CONTACT_NM_REGEX, errorMsg.CTC_NAME_REGEX_ERROR(label))
  .trim()
  .required(errorMsg.REQUIRED_ERROR(label));

export const userNameValidation = (label) => yup.string()
  .max(constraints.USER_IDENTIFIER_MAX, errorMsg.MAX_ERROR(label, constraints.USER_IDENTIFIER_MAX))
  .min(constraints.USER_IDENTIFIER_MIN, errorMsg.MIN_ERROR(label, constraints.USER_IDENTIFIER_MIN))
  .matches(constraints.USER_IDENTIFIER_REGEX, errorMsg.USER_IDENTIFIER_REGEX_ERR)
  .required(errorMsg.REQUIRED_ERROR(label));

export const phoneNoValidation = (label) => yup.string()
  .max(constraints.PHONE_NO_MAX, errorMsg.MAX_ERROR(label, constraints.PHONE_NO_MAX))
  .min(constraints.PHONE_NO_MIN, errorMsg.MIN_ERROR(label, constraints.PHONE_NO_MIN))
  .matches(constraints.PHONE_NO_REGEX, errorMsg.PHONE_NO_REGEX_ERR)
  .matches(constraints.PHONE_NO_REGEX_ALLOWED, errorMsg.PHONE_NO_REGEX_ALLOWED_ERR)
  .trim()
  .required(errorMsg.REQUIRED_ERROR(label));
